import logo from '../../../assets/img/logo.png';
class SettingsController {
  constructor(STRIPE_KEY, User, Plans, $uibModal) {
    "ngInject";
    this.STRIPE_KEY = STRIPE_KEY;
    this.name = 'settings';
    this.User = User;
    this.plans = Plans.getPlans();
    this.$uibModal = $uibModal;
    this.isAnnual = true;
  }
  $onInit() {
    this.loadCards();
    this.loadCurrentPlan();

    let self = this;
    let handler = StripeCheckout.configure({
      key: this.STRIPE_KEY,
      image: logo,
      locale: 'auto',
      token: function(token) {
        // You can access the token ID with `token.id`.
        // Get the token ID to your server-side code for use.
        console.log(token);
        self.User.updateCard(token).then(() => {
          console.log('card details updated');
          self.loadCards();
        })
      }
    });
    this.handler = handler;

    // Close Checkout on page navigation:
    window.addEventListener('popstate', function() {
      handler.close();
    });
  }

  loadCards() {
    this.User.getCards().then((response) => {
      let cards = response.data.cards;
      this.cards = cards.data;
    })
  }

  loadCurrentPlan() {
    this.User.getUserPlans().$loaded().then((userPlan) => {
      this.userPlan = userPlan;
      this.isAnnual = this.userPlan.is_annual;
    });
  }

  changeCard($event) {
    this.handler.open({
      name: 'interbot',
      panelLabel: 'Update card details'
    });
    $event.preventDefault();
  }
  cancelSubscription() {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'alertpopup',
      resolve: {
        body: () => {
          return "Are you sure you want to cancel your subscription?";
        }
      }
    });
    modalInstance.result.then((selectedItem) => {
      let selected = selectedItem;
      if (selected == 'yes') {
        this.cancelSubLoading = true;
        this.User.deactivateSubscription().then(() => {
          console.log('user plan deactivateSubscription');
          this.cancelSubLoading = false;
        });
      }
    }, () => {
      console.info('modal-component dismissed at: ' + new Date());
    });
  }

  changePlans(plan) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      component: 'alertpopup',
      resolve: {
        body: () => {
          return "Are you sure you want to change the plan?";
        }
      }
    });
    modalInstance.result.then((selectedItem) => {
      let selected = selectedItem;
      if (selected == 'yes') {
        plan.loading = true;
        this.User.changePlans(plan.id).then(() => {
          plan.loading = false;
          console.log('user plan updated');
        });
      }
    }, () => {
      console.info('modal-component dismissed at: ' + new Date());
    });
  }
}
export default SettingsController;



// WEBPACK FOOTER //
// ./client/app/components/home/settings/settings.controller.js